<div class="position-relative">
    <input
        type="text"
        class="form-control"
        [id]="inputId()"
        [placeholder]="placeholder()"
        autocomplete="off"
        [class.is-invalid]="invalid()"
        [disabled]="disabled()"
        [ngModel]="value()"
        (ngModelChange)="onInput($event)"
        (blur)="blurred.emit()"
    />
    @if (suggestions().length > 0) {
        <div class="list-group position-absolute w-100 shadow-sm mt-1 address-lookup-suggestions">
            @for (suggestion of suggestions(); track suggestion.id) {
                <button
                    type="button"
                    class="list-group-item list-group-item-action text-start"
                    (mousedown)="$event.preventDefault()"
                    (click)="onPick(suggestion.id)"
                >
                    {{ suggestion.text }}
                </button>
            }
        </div>
    }
</div>
